import { getPosts } from './ghost.js';

function formatDate(dateStr) {
  return new Date(dateStr).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

function escapeHtml(str) {
  const div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML;
}

function isValidUrl(url) {
  try {
    const parsed = new URL(url);
    return parsed.protocol === 'https:' || parsed.protocol === 'http:';
  } catch {
    return false;
  }
}

function makePlaceholder(spinning) {
  return '<div class="blog-card skeleton-card">' +
    '<div class="skeleton-card-image">' +
    '<div class="skeleton-card-star' + (spinning ? ' spinning' : '') + '">' +
    '<svg width="56" height="56" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M7.50034 19.7282V13.4562L2.04555 16.5922L0 13.0001L5.39797 9.86409L0 6.72811L2.04555 3.13598L7.50034 6.27196V0H11.6483V6.27196L17.0462 3.13598L19.0918 6.72811L13.6938 9.86409L19.0918 13.0001L17.0462 16.5922L11.6483 13.4562V19.7282H7.50034Z" fill="#7143FE"/>' +
    '</svg>' +
    '</div>' +
    '</div>' +
    '</div>';
}

function renderCards(posts) {
  const grid = document.querySelector('.blog-grid');
  if (!grid) return;

  if (!posts || posts.length === 0) {
    grid.innerHTML =
      '<p style="color: var(--color-text-muted); font-family: \'DM Sans\', sans-serif; grid-column: 1 / -1; text-align: center;">No posts yet. Check back soon!</p>';
    return;
  }

  var skeletons = grid.children;

  var spinners = grid.querySelectorAll('.skeleton-card-star.spinning');
  spinners.forEach(function(el) {
    el.classList.remove('spinning');
    el.style.animation = 'none';
  });

  posts.forEach(function(post, i) {
    if (i >= skeletons.length) return;

    var slug = encodeURIComponent(post.slug);
    var imageStyle =
      post.feature_image && isValidUrl(post.feature_image)
        ? "background-image: url('" + encodeURI(post.feature_image) + "')"
        : '';

    var wrapper = document.createElement('div');
    wrapper.style.position = 'relative';
    wrapper.innerHTML =
      '<a href="/blog/' + slug + '" class="blog-card-link blog-card-fade-in">' +
      '<article class="blog-card">' +
      '<div class="blog-card-image" style="' + imageStyle + '"></div>' +
      '<div class="blog-card-content">' +
      '<span class="blog-card-date">' + escapeHtml(formatDate(post.published_at)) + '</span>' +
      '<h3 class="blog-card-title">' + escapeHtml(post.title) + '</h3>' +
      '<p class="blog-card-excerpt">' + escapeHtml(post.custom_excerpt || post.excerpt || '') + '</p>' +
      '</div>' +
      '</article>' +
      '</a>';

    var realCard = wrapper.firstChild;
    var target = skeletons[i];

    setTimeout(function() {
      grid.replaceChild(realCard, target);
      requestAnimationFrame(function() {
        realCard.classList.add('visible');
      });
    }, 300 + i * 120);
  });
}

function showLoading() {
  const grid = document.querySelector('.blog-grid');
  if (!grid) return;
  var existing = grid.querySelectorAll('.skeleton-card');
  if (existing.length === 0) {
    grid.innerHTML = makePlaceholder(true).repeat(3);
  }
}

function showError() {
  const grid = document.querySelector('.blog-grid');
  if (!grid) return;
  grid.innerHTML =
    '<p style="color: var(--color-text-muted); font-family: \'DM Sans\', sans-serif; grid-column: 1 / -1; text-align: center;">Unable to load posts. Please try again later.</p>';
}

async function init() {
  showLoading();
  var minDelay = new Promise(function(resolve) { setTimeout(resolve, 1200); });
  try {
    var results = await Promise.all([getPosts(), minDelay]);
    renderCards(results[0]);
  } catch (err) {
    console.error('Failed to fetch posts:', err);
    showError();
  }
}

init();
